<script>
  export let idUnico = 'spacey';
  export let content;
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';

  let param = [];

  onMount(() => {
    content = content.trim();
    param = content.split(',');
  });
</script>

<div class="space-y" style="--height-y: {param[0]}; --margin-b: {param[1]}"></div>

<style>
  .space-y {
    height: var(--height-y);
    margin-bottom: var(--margin-b);
  }
  @media (max-width: 800px) {
  }
</style>
